const apiUrl = process.env.REACT_APP_API_URL;
export const GetInscripcions = async ( cognom: string, dni : string,  page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ cognom, dni })
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
